import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { __ } from '@wordpress/i18n';

// store
import { storeSet } from '../../store';
import { historyStore } from '../../store/historyStore';

// components
import ModalDialog from '../ModalDialog';
import ButtonFlat from '../ButtonWrapper/components/ButtonFlat';
import ButtonFormSubmit from '../ButtonWrapper/components/ButtonFormSubmit';

// styles
import '../../assets/components/ModalEditTimecode.css';

const ModalEditTimecode = ({ visible, onHide, trackId, currentTimecode, trackTitle }) => {
    const { projectId } = useParams();
    const [timecode, setTimecode] = useState(currentTimecode ?? '');
    const [loading, setLoading] = useState(false);

    // The field is seeded each time the modal opens, and only then: following
    // `currentTimecode` while closed re-rendered on every timeline update, and
    // while open it wiped what was being typed.
    useEffect(() => {
        if (visible) setTimecode(currentTimecode ?? '');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible]);

    const handleSubmit = async () => {
        if (!trackId || !timecode) return;
        setLoading(true);
        try {
            historyStore.getState().beginAction('Edit Timecode');
            await storeSet('saveCueSheetUpdates', projectId, [{ id: trackId, timecode }]);
            onHide();
        } catch (e) {
            // error handled by store
        } finally {
            setLoading(false);
        }
    };

    const isDisabled = loading || !timecode || timecode === (currentTimecode ?? '');

    return (
        <ModalDialog
            additionalClasses={['ModalEditTimecode']}
            header={trackTitle
                ? `${__('Edit timecode', 'soundbetween')}: ${trackTitle}`
                : __('Edit timecode', 'soundbetween')}
            visible={visible}
            onHide={onHide}
            onSubmit={handleSubmit}
            width={380}
        >
            <form
                className="appForm formInModal"
                onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}
            >
                <div className="ModalEditTimecode__field">
                    <label className="ModalEditTimecode__label" htmlFor="tc-timecode-input">
                        {__('Timecode', 'soundbetween')}
                    </label>
                    <input
                        id="tc-timecode-input"
                        className="ModalEditTimecode__input"
                        type="text"
                        value={timecode}
                        onChange={(e) => setTimecode(e.target.value)}
                        placeholder="00:00:00:00"
                        autoFocus
                    />
                </div>
                <div className="appFormActions">
                    <ButtonFlat size="lg" type="button" onClick={onHide}>
                        {__('Cancel', 'soundbetween')}
                    </ButtonFlat>
                    <ButtonFormSubmit disabled={isDisabled}>
                        {__('Apply', 'soundbetween')}
                    </ButtonFormSubmit>
                </div>
            </form>
        </ModalDialog>
    );
};

export default ModalEditTimecode;
